import IconButton from "../icon-button";
import {
  StyledDialog,
  StyledDialogContent,
  StyledDialogTitle,
  StyledDialogTitleWrapper,
} from "./midia-file-dialog-styles";
import { TQrcodeDialogProps } from "./types";

const MidiaFileDialog = ({
  isOpen,
  onClose,
  children,
}: TQrcodeDialogProps) => {
  
  return (
    <StyledDialog
      open={isOpen}
      onClose={onClose}
    >
      <StyledDialogTitleWrapper>
        <StyledDialogTitle>Mídia</StyledDialogTitle>
        <IconButton
          onClick={onClose}
          isWhite
          iconSize={1.5}
        />
      </StyledDialogTitleWrapper>
      <StyledDialogContent>
        {children}
      </StyledDialogContent>
    </StyledDialog>
  )
};

export default MidiaFileDialog;